import { TFunction } from "i18next";
export type TranslateFunction = (key: string) => string;

const useTranslate = (t: TFunction<string>) => {
    const translate: TranslateFunction = (key: string): string => t(key);

    return { translate };
};

export default useTranslate;